<template>
  <form @submit.prevent="onSearch" class="mb-4">
    <div class="row">
      <div class="col-lg-3 col-md-6 col-sm-12">
        <BaseInput
            v-model="filters.firstName"
            :placeholder="$t('general.first_name')"
            :label="false"
            type="text"/>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <div class="form-group">
          <BaseInput
              v-model="filters.lastName"
              :placeholder="$t('general.last_name')"
              :label="false"
              type="text"/>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <div class="form-group">
          <BaseInput
              v-model="filters.city"
              :placeholder="$t('general.city')"
              :label="false"
              type="text"/>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <div class="form-group">
          <BaseInput
              v-model="filters.company"
              :placeholder="$t('general.company_client')"
              :label="false"
              type="text"/>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <div class="form-group">
          <BaseInput
              v-model="filters.phoneNumber"
              :placeholder="$t('general.phone_number')"
              :label="false"
              type="text"/>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <div class="form-group">
          <BaseInput
              v-model="filters.position"
              :placeholder="$t('general.position')"
              :label="false"
              type="text"/>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <div class="form-group">
          <BaseInput
              v-model="filters.email"
              :placeholder="$t('general.email')"
              :label="false"
              type="text"/>
        </div>
      </div>

      <div v-if="federalStatesDropdown && federalStatesDropdown.length" class="col-lg-3 col-md-6 col-sm-12">
        <SelectVue
            v-model="filters.federalState"
            :options="federalStatesDropdown"
            :is-clear="true"
            :placeholder="$t('placeholder.select_federal_state')"/>
      </div>
      <div v-else>
        <div class="col-lg-3 col-md-6 col-sm-12">
          <SearchButton
              type="submit"
              :label="$t('general.button.search')"
              :loading="loading"/>
        </div>
      </div>
    </div>

    <div v-if="type === 'client'" class="row justify-content-center align-items-center">
      <div class="col-lg-2 col-sm-12 col-12">
        <SearchButton
            type="submit"
            :label="$t('general.button.search')"
            :loading="loading"/>
      </div>
    </div>

  </form>
</template>

<script setup>
import BaseInput from '@/components/base/BaseInput.vue';
import SelectVue from '@/components/SelectVue.vue';
import {defineEmits, defineProps, toRefs} from 'vue';
import SearchButton from "@/components/button/SearchButton.vue";

const props = defineProps({
  filters: {
    type: Object,
    required: true,
  },
  federalStatesDropdown: {
    type: Array,
    required: false,
    default: () => [],
  },
  loading: {
    type: Boolean,
    default: false,
  },
  type: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['search']);

const {filters, federalStatesDropdown} = toRefs(props);

function onSearch() {
  emit('search', 1, undefined, filters.value);
}

</script>

<style scoped>
</style>
